'use strict'

import CloudDataConnector from '../api.js'
import Plot from './base.js'

export default class PlotTemperatureDeviation extends Plot {
  constructor () {
    super('temperature-deviation')
  }

  async dataFunction (controller) {
    // Get data from API
    const [seasonResponse, normalResponse] = await Promise.all([
      new CloudDataConnector().getSeasonMeanTemperatures(controller.uiElements.station.val(), controller.uiElements.season.val()),
      new CloudDataConnector().getSeasonNormalTemperatures(controller.uiElements.station.val(), controller.uiElements.season.val())
    ])
    const height = controller.uiParams.height

    const seasonData = seasonResponse.sort((left, right) => left.year < right.year ? -1 : (left.year > right.year ? 1 : 0))
    const normalData = normalResponse[0]

    const dataPoints = seasonData.map(item => item.sensor_2m - normalData.sensor_2m)
    const dataBase = seasonData.map(() => 0)
    const xaxis = seasonData.map(item => item.year)
    const colors = dataPoints.map(item => item < 0 ? '#00bcd5' : '#ffac2b')

    // Return elements to give to Plotly
    return {
      data: [
        {
          x: xaxis,
          y: dataPoints,
          base: dataBase,
          type: 'bar',
          marker: {
            color: colors
          }
        }
      ],
      layout: {
        xaxis: { title: 'Année', autotick: false },
        yaxis: { title: 'Ecart (en °C)' },
        margin: { t: 0 },
        height
      }
    }
  }
}
